import RegInfoList from 'src/pages/RegistrationInfo';

export const registrationInfoRoutes = [
  { path: '/info/registration', component: RegInfoList },
];
